export default "__VITE_ASSET__BJefFrw7__"